import React, { useEffect, useState } from "react";
import {
  Col,
  Container,
  Row,
  Form,
  CardBody,
  Card,
  Label,
  Input,
  Button,
} from "reactstrap";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import BreadCrumb from "Components/Common/BreadCrumb";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { updateAddress } from "live-slices/business/thunk";
import { createSelector } from "reselect";
import Select from "react-select";
import { getCities, getStates, getZones } from "live-slices/address/thunk";
import AddressFormBox from "Components/Common/AddressFormBox";
import { useNavigate } from "react-router-dom";
import { updateUserState } from "live-slices/user/reducer";
import TPLMapComponent from "Components/Common/TPLMap";

// Register the plugins

const WareHouseAddress = (props: any) => {
  document.title = "Shop Address | BuyPass";
  const dispatch: any = useDispatch();
  const navigate = useNavigate();

  const [address, setaddress] = useState<any>();
  const [returnaddress, setreturnaddress] = useState<any>();




  const selectuserProfile = createSelector(
    (state: any) => state.Business,
    (business) => business?.business
  );


  const selectUser = createSelector(
    (state: any) => state.User,
    (user) => user?.user,
  );

  const user = useSelector(selectUser)
  const seller = useSelector(selectuserProfile);

  useEffect(() => {
  }, [seller]);



  const validationSchema = Yup.object({
    // streetAddress: Yup.string()
    //   .required("Address details are required")
    //   .min(5, "Address must be at least 5 characters long"),
    // state: Yup.string()
    //   .required("Region/City/District is required"),
  });

  // Initialize Formik
  const formik = useFormik({
    initialValues: {
      address: {
        zone: "",
        zoneId: "",
        city: "",
        cityId: "",
        state: "",
        stateId: "",
        streetAddress: "",
        regionState: "",
        isPlaza: true,
        plazaMarketName: "",
        shopName: "",
        shopNumber: "",
        isSameAddress: true, // For checkbox
        latitude: 0, // Initial value for latitude
        longitude: 0,
        coordinates: [] as number[], 
      }
    },
    validationSchema,
    onSubmit: (values) => {
      const updatedSeller = {
        ...seller,
        
        returnAddress: returnaddress,
        isReturnAddressSame: true,
      };
      if (address) {
        updatedSeller.address = address;
      }

      dispatch(updateAddress({ formData: updatedSeller, navigate })).then(() => {
        dispatch(
          updateUserState({
            storeStatus: {
              ...user.storeStatus,
              isAddressAdded: true,
            },
          })
        );
      })
    },
  });



  const onWarehouseAddressChange = (address: any) => {
    setaddress(address);
  }

  const onReturnAddressChange = (address: any) => {
    setreturnaddress(address);
  }


  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Shop Address" pageTitle="Ecommerce"  pageTitleRoute="/on-boarding" />

        <Row>
          <div className="flex-grow-1 mt-2 mb-2 ">
            <h5 className="card-title mb-0">Please add your pick-up address to make your products visible to customer</h5>
          </div>
          <Col lg={12}>
            <Form onSubmit={formik.handleSubmit}>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <h5 className="fs-14 mb-3">Shop Address</h5>
                    <AddressFormBox addressObject={seller && seller.address ? seller.address : undefined} onAddressUpdate={(address) => { onWarehouseAddressChange(address) }} />

                  </CardBody>
                </Card>
              </Col>




              {/* Submit Button */}
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <div className="d-flex justify-content-end">
                      <Button type="submit" color="primary" data-testing-Id="submitButton_onBoardingAddress" className="ml-auto">
                        Submit
                      </Button>
                    </div>
                    
                  </CardBody>
                </Card>
                {/* <Card>
                  <CardBody>
                  <h5 className="fs-14 mb-3">Shop Address</h5>
                    <AddressFormBox addressObject={seller && seller.address? seller.address:undefined} onAddressUpdate={(address)=>{onWarehouseAddressChange(address)}}  />
                  </CardBody>
                </Card> */}

                
              </Col>
              <Col lg={12}>
                
              </Col>
            </Form>
          </Col>

        </Row>
      </Container>
    </div>
  );
};

export default WareHouseAddress;
